<template>
    <BannerSkeleton v-if="isLoading" />
    <div class="double-banner-content">
        <div
          v-for="(item, index) in bannerItems"
          :key="index"
           
        >
        <a :href="item.url" target="_blank">
          <img
            class="bannerSlider_image"
            :src="item.imageUrl.replace('{0}', '460_174')"
          />
        </a>
        </div>
    </div>
</template>
  
  <script>

  import BannerSkeleton from '../Slider/BannerSkeleton';
  
  export default {
    name: 'DashboardLeftFirstDoubleBanner',
    components: {
      BannerSkeleton,
    },
    props: {
      bannerItems: {
        type: Array,
        required: true,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      clickHandler(url) {
        window.location = url;
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  @import '@/assets/styles/variables.scss';
  .bannerSlider {
    &_image {
      width: 460px;
      height: 174px;
     flex-shrink: 0;
     flex-wrap:wrap;
     border-radius: 8px;
    }
  
  }
  .double-banner-content {
    display: flex;
    flex-wrap:wrap;
    height: 174px;
    align-items: flex-start;
    gap: 24px;
    flex: 1 0 0;

  }

  </style>
  